import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { MsgError, MsgLoading, MsgSuccess } from '../../../components/Loaders/MessageLoaders'
import DeleteModal from '../../../components/Modal/DeleteModal'
import Table from '../../../components/Table/Table'
import AmenitiesService from '../../../services/AmenitiesService'
const tableHeaders = [
    {
        id: 1,
        title: 'id'
    },
    {
        id: 2,
        title: 'amenity'
    },
    {
        id: 3,
        title: 'amenity_icon',
        img: true
    },
]
const TabViewAmenities = () => {
    const [data, setData] = useState([])
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
    const [currentId, setCurrentId] = useState<string>('')
    const [refreshTable, setRefreshTable] = useState<boolean>(false);

    const handleDelete = async () => {
        try {
            MsgLoading()
            const res = await AmenitiesService.deleteAmenity(currentId)
            MsgSuccess(res.data.msg)
            setRefreshTable(!refreshTable)
            setIsDeleteModalOpen(false)
        } catch (error: any) {
            console.log(error)
            MsgError(error.response.data.msg || 'Can not delete this item !')
        }

    }
    const handleDeleteModal = (id: string) => {
        setCurrentId(id)
        setIsDeleteModalOpen(true)
    }
    const actionProps = {
        handleDelete: handleDeleteModal,
    }


    useEffect(() => {
        AmenitiesService.getAllAmenities().then(res => {
            setData(res.data.data)
        }).catch((error: any) => {
            console.log(error);
        })

    }, [refreshTable])
    return (
        <div>
            <Table tableBody={data} tableHeaders={tableHeaders} actions={actionProps} />
            <DeleteModal isDeleteModalOpen={isDeleteModalOpen} setIsDeleteModalOpen={setIsDeleteModalOpen} handleDelete={handleDelete} title='Amenity' />

        </div>
    )
}

export default TabViewAmenities